function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H60C62.2091 0 64 1.79086 64 4V39C64 41.2091 62.2091 43 60 43H4C1.79086 43 0 41.2091 0 39V4Z",
  fill: "#CCECFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.0076 34.9998C42.4026 35.0358 49.153 28.982 49.153 21.6172C49.153 13.5641 42.4026 7.99769 35.0076 8H28.6435C21.1599 7.99769 15 13.5654 15 21.6172C15 28.9836 21.1599 35.0358 28.6435 34.9998H35.0076Z",
  fill: "#016AAB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.482 28.7885V14.1647C34.4276 15.2923 36.5187 18.1382 36.5236 21.4761C36.5187 24.8147 34.4276 27.6589 31.482 28.7885ZM20.8251 21.4761C20.8317 18.1402 22.9195 15.296 25.8634 14.1651V28.7855C22.9195 27.6556 20.8317 24.813 20.8251 21.4761ZM28.6732 9.11615C21.835 9.11846 16.2937 14.6499 16.2921 21.4761C16.2937 28.3017 21.835 33.8321 28.6732 33.8341C35.5138 33.8321 41.0561 28.3017 41.057 21.4761C41.0561 14.6499 35.5138 9.11846 28.6732 9.11615Z",
  fill: "white"
});

function SvgDinersMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 43,
    viewBox: "0 0 64 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersMedium);
export default __webpack_public_path__ + "static/media/diners-medium.1080553c.svg";
export { ForwardRef as ReactComponent };